<div class="container py-4 text-center">
  <div class="position-relative">

    <!-- Carrusel -->
    <div class="d-flex justify-content-center align-items-center gap-5 py-3">
      <div *ngFor="let item of getVisibleItems(); trackBy: trackByFn"
           class="card carousel-card border-0 carousel-card-rounded shadow transition"
            [ngClass]="getCardClassesByPosition(item.position)">

        <img [src]="item.image | directus"  data-src="{{item.image | directus}}" [alt]="item.title" class="img-fluid carousel-img-rounded-top" />
        <div class="card-body">
          <p class="card-text text-muted small">{{ item.description }}</p>
          <a [href]="item.link " target="_blank"
             class="fw-bold text-decoration-none text-primary">
            {{ item.link | stripProtocol }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Controles con diseño exacto -->
  <div class="d-flex justify-content-center align-items-center gap-2 mt-4">
    <!-- Botón previo -->
    <button (click)="prev()" class="carousel-arrow">
      &#10094;
    </button>

    <!-- Indicadores -->
    <div class="d-flex align-items-center gap-2">
      <span *ngFor="let _ of items; let i = index"
            (click)="goToSlide(i)"
            class="carousel-indicator"
            [class.active]="i === currentIndex"></span>
    </div>

    <!-- Botón siguiente -->
    <button (click)="next()" class="carousel-arrow">
      &#10095;
    </button>
  </div>

</div>
